module.exports = __webpack_public_path__ + "4f605e6d3392725e83a38d79f8d81cba.png";